import * as angular from "angular";
import {IController, IOnChangesObject, IScope, ITimeoutService} from "angular";

export class shippersTableRowCtrl implements IController {

  shippersTableCtrl: any;
  shipperId: any;
  shipper: any;


  /* @ngInject */
  constructor(private $shipper, private $scope: IScope, private $timeout: ITimeoutService) {
  }

  $onInit() {
    this._bindShipper();

  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.shipperId && !changes.shipperId.isFirstChange()) {
      this._bindShipper();
    }
  }

  onOpen($mdMenu, ev) {
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  onActivateOrDeactivateShipper() {
    const shipperCopy = angular.copy(this.shipper);
    shipperCopy.active = !shipperCopy.active
    this.shippersTableCtrl.onActivateOrDeactivateShipper({shipper: shipperCopy})
  }

  private _bindShipper() {
    if (this.shipperId) {
      this.$shipper(this.shipperId).$bindCtrlToId(this.$scope, this, 'shipper', 'shipperId');
    }
  }

}

angular
  .module('bringoz.admin.shippers')
  .component('shippersTableRow', {
    require: {
      shippersTableCtrl: '^shippersTable'
    },
    bindings: {
      shipperId: '<'
    },
    template: require('./shippers-table-row.html').default,
    controller: shippersTableRowCtrl
  });
